import { Text, Title, Divider, Group, ThemeIcon, Badge } from "@mantine/core";
import React from "react";
import moment from "moment";
import InfoGridList from "./infoGridList";
import { useCellRender } from "../hooks/useCellRender";

import { IconClick, IconCash, IconHeart } from "@tabler/icons";
import { useTranslation } from "react-i18next";

export default function UserEmploymentInfo({ form }) {
  const { t } = useTranslation();
  const [cellRender] = useCellRender();
  const user = form.values;
  const dataFontWeight = 600;

  const emptyStr = "-";
  const fmt = (v) =>
    v === null || v === undefined || v === "" ? emptyStr : v;

  const fields = [
    { title: "Login Email", value: fmt(user.email) },

    { title: t("Work Title"), value: fmt(user.workTitle) },
    { title: "User Type", value: fmt(user.userType) },
    { title: "User Role", value: fmt(user.userRole?.name) },

    {
      title: "Join Date",
      value: user.employmentDate
        ? cellRender.Date(user.employmentDate, "YYYY-MM-DD")
        : emptyStr,
    },
    {
      title: t("Resignation Date"),
      value: user.termination?.resignDate
        ? cellRender.Date(user.termination.resignDate, "YYYY-MM-DD")
        : emptyStr,
    },
    { title: "Access Card Number", value: fmt(user.accessCardNumber) },
    { title: "Octopus Number", value: fmt(user.octopusNumber) },
    { title: "Qualifications", value: fmt(user.qualifications) },
    {
      title: "Created At",
      value: user.createdAt
        ? cellRender.Date(user.createdAt, "YYYY-MM-DD", dataFontWeight)
        : emptyStr,
    },
  ];
  return user && <InfoGridList fields={fields} values={user} />;
}
